import { Button } from "@mui/material";
import { Checkbox } from "@mui/material";

export const getHeaderConfig = (
  viewPR,
  status,
  usedIn,
  handleRowSelection,
  selectedPrList,
  dataList
) => {
  const headers = [
    {
      id: "checkbox",
      label: (
        <Checkbox
          onChange={(event) => handleRowSelection(event, null, "selectAll")}
          checked={
            selectedPrList.length === dataList.length && dataList.length !== 0
          }
        />
      ),
      sortable: false,
      render: (data) => (
        <Checkbox
          checked={selectedPrList.find((ele) => ele.id === data.id) ? true : false}
          onChange={(event) => handleRowSelection(event, data)}
        />
      ),
    },
    {
      label: "PR Number",
      id: "prNumber",
      render: (data) => {
        const { document = {} } = data;
        return document?.prNumber || data.documentId || "";
      },
    },
    {
      label: "Store",
      id: "store",
      render: (data) => {
        const { site, document = {} } = data;
        if (site?.code || site?.name) {
          return `${site.code || ""} - ${site.name || ""}`;
        }
        if (document?.siteCode || document?.siteName) {
          return `${document.siteCode || ""} - ${document.siteName || ""}`;
        }
        return "";
      },
    },
    {
      label: "Department",
      id: "department",
      render: (data) => {
        const { document = {} } = data;
        return document?.department || "-";
      },
    },
    {
      label: "PR Type",
      id: "prType",
      render: (data) => {
        const { document = {} } = data;
        return document?.prType || "-";
      },
    },
    {
      label: "Total Amount",
      id: "totalAmount",
      render: (data) => {
        const { document = {} } = data;
        const amount = document?.totalEstimatedGrossAmount;
        if (amount == null) return "-";
        return `₹${Number(amount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}`;
      },
    },
    {
      label: "Current Stage",
      id: "currentStage",
      render: (data) => {
        const stages = data?.stages || [];
        if (!stages.length) return "-";
        const lastStage = stages[stages.length - 1];
        return lastStage?.stageName || lastStage?.stageRoleName || "-";
      },
    },
    {
      label: "Date",
      id: "createdAt",
      render: (data) => {
        if (!data.createdAt) return "-";
        return new Date(data.createdAt).toLocaleDateString("en-IN");
      },
    },
    {
      label: "Pending With",
      id: "pendingWith",
    },
    {
      label: "Created By",
      id: "creatorName",
      render: (data) => {
        const { document = {} } = data;
        return document?.creatorName || "";
      },
    },
    {
      label: "Actions",
      id: "actions",
      render: (data) => (
        <Button variant="text" onClick={() => viewPR(data)}>
          View
        </Button>
      ),
    },
  ];
  return headers;
};
